import React from "react";
import { clockLabel } from "../../utils/consolidationPresentation.js";

const CHRONOLOGY_LIMITS = {
  inspection_end: ["avant la fin de l’inspection", "Vérifiez cette heure, le début du service ou le départ du camion."],
  previous_departure: ["avant le départ de l’arrêt précédent", "Vérifiez cette heure et les départs précédents."],
  service_end: ["après la fin du service", "Vérifiez ce départ ou la fin du service."],
  departure: ["après l’heure quittée", "Vérifiez cette arrivée et ce départ."],
};

// Name the saved hour that breaks the chronology and the bound it crosses.
export function ChronologyAlert({ visit, row, error, hideArrival }) {
  const clock = (value) => clockLabel(value, row.timezone, row.dispatch_date);
  const [bound, advice] = CHRONOLOGY_LIMITS[error.limit_kind] || [];
  const field = error.limit && bound && visit[error.field] ? error.field : null;
  const limit = Date.parse(error.limit);
  const arrivalAlso = field === "departure" && visit.arrival
    && (error.limit_kind === "service_end" ? Date.parse(visit.arrival) > limit : Date.parse(visit.arrival) < limit);
  const fallback = visit.arrival ? "arrival" : visit.departure ? "departure" : null;
  const saved = (name) => name === "arrival" ? "Heure d’arrivée saisie" : "Heure quittée saisie";
  return <div role="alert" className="grid gap-1 text-[11px] text-red-700">
    <span>{error.message}</span>
    {field ? <span>{saved(field)} : <strong>{clock(visit[field])}</strong>, {bound} (<strong>{clock(error.limit)}</strong>).{arrivalAlso ? <> Heure d’arrivée saisie : <strong>{clock(visit.arrival)}</strong>.</> : null} {advice}</span>
      : fallback ? <span>{saved(fallback)} : <strong>{clock(visit[fallback])}</strong>. Vérifiez cette heure et les départs.</span> : null}
    {hideArrival && visit.arrival && (field !== "departure" || arrivalAlso) ? <span>Cochez « Heure d’arrivée » dans Affichage pour afficher et corriger cette heure.</span> : null}
  </div>;
}
